export const CHAT_INPUT_MAX_LENGTH = 500;
